import { Paper, styled, Typography } from '@mui/material';
import { theme } from 'assets/themes/zizzi';
import Alert from 'components/Alert';
import Markdown from 'components/Markdown';

const textColor = theme.palette.white;
const listSpacing = '1.5rem';

export const StyledPaper = styled(Paper)`
  background: ${theme.palette.primary.main};
  border-radius: ${theme.radius.md};
`;

export const Title = styled(Typography)`
  color: ${textColor};
`;

export const Text = styled(Markdown)`
  color: ${textColor};

  ol {
    padding-inline-start: ${listSpacing};
    margin-bottom: ${listSpacing};
  }
`;

export const StyledAlert = styled(Alert)`
  &.MuiAlert-root {
    background: transparent;
    border: 2px solid ${textColor};

    .MuiAlert-icon,
    .MuiAlert-message {
      color: ${textColor};
    }
  }
`;
